module.exports = __webpack_public_path__ + "static/media/ararat_bouw.31e6027a.png";